module.exports = __webpack_public_path__ + "img/owl-blue-left.71dc1472.png";